<div *ngIf="ddptInfo" class="container card-detail-container">
  <h1 class="alert alert-secondary display-4 plate font-weight-bold">Detalji o DDPK</h1>
  <div class="card shadow-sm p-4 rounded">
    <div class="row g-0 align-items-center">
      <div class="col-md-4 d-flex justify-content-center">

        <div class="card">
          <div class="image-container">
            <div *ngIf="images.length; else noImageTemplate">
              <gallery class="image-thumbnail"
                       (itemClick)="onImageClick($event)"
                       [thumbs]="false"
                       [items]="images"></gallery>
            </div>
          </div>
        </div>
      </div>


      <div class="col-md-8">
        <div class="card-body">

          <div class="row mb-2">
            <div class="col-1 d-flex align-items-center">
              <i class="fa fa-clock" title="Datum i vrijeme izdavanja DDPK"></i>
            </div>
            <div class="col-11 d-flex flex-column flex-md-row ">
              <div class="plate lead label font-weight-bold">Datum i vrijeme izdavanja:</div>
              <div class="plate font-weight-bold">{{ ddptInfo.ddptValidFrom }}</div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-1 d-flex align-items-center">
              <i class="fa fa-map-marker" title="Lokacija izdavanja DDPK"></i>
            </div>
            <div class="col-11 d-flex flex-column flex-md-row">
              <div class="plate label font-weight-bold">Lokacija izdavanja:</div>
              <div class="plate font-weight-bold">{{ ddptInfo.location }}</div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-1 d-flex align-items-center">
              <i class="fa fa-car" title="Registracija vozila"></i>
            </div>
            <div class="col-11 d-flex flex-column flex-md-row ">
              <div class="plate label font-weight-bold">Registracija vozila:</div>
              <div class="plate font-weight-bold">{{ ddptInfo.licensePlate }}</div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-1 d-flex align-items-center">
              <i class="fa fa-ticket" title="Zona"></i>
            </div>
            <div class="col-11 d-flex flex-column flex-md-row ">
              <div class="plate label font-weight-bold">Zona:</div>
              <div class="plate font-weight-bold">{{ ddptInfo.zoneInfo }}</div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-1 d-flex align-items-center">
              <i class="fa fa-euro-sign" title="Cijena"></i>
            </div>
            <div class="col-11 d-flex flex-column flex-md-row ">
              <div class="plate label font-weight-bold">Cijena:</div>
              <div class="plate font-weight-bold">{{ ddptInfo.price }}</div>
            </div>
          </div>

          <div class="card-time text-muted mt-2">
            <div class="row">
              <div class="col-1 d-flex align-items-center">
                <i class="fa fa-calendar" title="Važenje DDPK"></i>
              </div>
              <div class="col-11 d-flex flex-column flex-md-row ">
                <div class="plate label font-weight-bold">Važenje DDPK:</div>
                <div class="plate font-weight-bold">{{ ddptInfo.ddptValidFrom }} - {{ ddptInfo.ddptValidTill }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="companyOid === '4028319f533e2b8101535093ed6e4c76' && ddptInfo.ddptNumber" class="plate font-weight-bold ms-md-3">
      <button
        mat-raised-button
        color="primary"
        (click)="openInstantPay()">
        Plati DDPK
      </button>
    </div>
  </div>

  <div *ngIf="companyOid === '4028319f533e2b8101535093ed6e4c76'" class="text-center mt-4">
    <a href="http://www.bestinparking.hr" target="_blank">http://www.bestinparking.hr</a>
  </div>

</div>

<div *ngIf="companyOid === '402880a825447882012544788b750002'" class="container mt-4">
  <p class="text-center text-muted">
    Za dodatne informacije o izdanim DDPK ili o plaćanju iste možete se obratiti putem maila na adresu
    <a href="mailto:infozgp&#64;zgh.hr">infozgp&#64;zgh.hr</a>
    ili putem telefona
    <a href="tel:072500400">072 500 400</a>.
  </p>
</div>

<ng-template #noImageTemplate>
  <div *ngIf="isLoading | async as loading">

    <div *ngIf="!loading">
      <img [src]="'https://placehold.co/600x400?text=No+Images'" class="img-fluid rounded" alt="No Image"/>
    </div>

    <div *ngIf="loading">
      <img [src]="'https://placehold.co/600x400?text=Loading+Images...'" class="img-fluid rounded" alt="Loading..."/>
    </div>

  </div>
</ng-template>

